module.exports = __webpack_public_path__ + "static/media/radio-dark.7f07ad07.svg";